import __request__ from "routing/request";
export function getAllRetrievalResults(query, page = 1, per_page = 50, sort, order = "asc", filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/retrievals", null, { "query": query, "page": page, "per_page": per_page, "sort": sort, "order": order, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
